module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }), _c('span', {
    staticClass: "small"
  }, [_vm._v("THREE")])]), _vm._v(" "), _c('p', {
    staticClass: "noindenta"
  }, [_vm._v("Is she dead?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Harry!” she calls. “Am I dead?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She has to move. Of course she has to move. After a certain age, the body must be kept moving or the bones will seize. Where is she? She hasn’t done her walk today: half-mile down the hill, half-mile up. She’s walked the hill so many years, she can do it in her sleep. Twice a week, and she misses occasionally, but the walk has kept her fit. She can do it in winter in her Bama Lams; she can do it in spring and summer and fall.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s cold. Shaking. She’s been unconscious—or was it only sleep? She has seen the most unusual tree. She is on her way somewhere. But where?")]), _vm._v(" "), _c('p', {
    staticClass: "blockquote"
  }, [_vm._v("The queen did not like him, nor did the king"), _c('br'), _vm._v("So Hector Protector was sent home again")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Sequential disarray.")]), _vm._v(" She remembers those two words. What do they mean? She’s somewhere, lining up her thoughts. Flat "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }), _vm._v("on her back, but she’s not sure where. Most certainly not in her bed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Concentrate. Think of the bones")]), _vm._v(", she tells herself. "), _c('em', [_vm._v("Are there any broken bones?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ones she can’t move.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Try the left leg.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It bends.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Try the right.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pain, shooting through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Fingers?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fine.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Left arm?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s fine, too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Right arm?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She’s afraid to lift. Her shoulder might be crushed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Spine?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She can wiggle her toes. She wouldn’t be able to if her spine …")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She must not be morbid. She thinks of Hubley the skeleton, rattling off the page of her grandfather’s anatomy book, the one she discovered at the country house the year she started school. At one time, she could rhyme off every one of Hubley’s bones.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cranium: occipital, frontal, parietal. She’s missing some. Slowly now. Temporal, maxillary, mandible.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Vomer, shaped like a ploughshare. A fossil of memory jumps to her consciousness like an old secret revealed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Atlas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Axis. The pivot that allows her to turn her head.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She raises her head the tiniest bit. Turns it a little, tips it to the right and back. Sees bushes, trees; a feather, snagged by a burr of rock; a curved rib, rubbed grey—not human. And there, "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }), _vm._v("in a clearing behind her, the length of a room away, is the car, bashed and battered, the driver’s door sprung. How can the car be upright when it flipped and somersaulted all the way down? It hit branches, a tree; she was inside, she should know. There isn’t much to remember. How then? She’s been thrown clear. The door is wide open. Was she not wearing her belt?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("Not this time.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So, it’s her own fault.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She could bend one knee, push with one foot, attempt to get to the car, inch by inch on her back, reach up inside, honk the horn. But her head is resting on a thin ridge of rock. The only way to relieve the pain is to raise her head, let it loll, bang it down. And the pain starts all over again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What would the Queen do?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Queen would not have been behind the wheel. She’d have had a chauffeur.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She was on her way to the palace. Her face has been slammed. Her mouth is dry and cold as ash. She might go into shock. "), _c('em', [_vm._v("The first principle of healing is rest.")]), _vm._v(" She learned that from Grandfather’s medical books. Why did Harry have to buy a black car? No one will see it down here when dusk falls. Only a moment ago, it was morning. She saw Case in daylight, and that was afternoon. Someone lifted something orange into the car. Her daughter. Case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She said her farewells.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But who is she?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She wonders if someone like her has been given a name.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("She sleeps.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c18b27f4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch03.vue
// module id = 93
// module chunks = 0